<template>
    <v-container fill-height class="main-container">
        <div class="box">
            <v-row class="-mb38">
                <v-col cols="12" md="9">
                    <v-row>
                        <v-col cols="12" md="4" class="-mb30">
                            <SelectArea
                                @selected="areaSelected"
                                :aux_data="2"
                                :dense="true"
                                :clear="clearArea"
                            ></SelectArea>
                        </v-col>
                        <v-col cols="12" md="4" class="-mb30">
                            <v-menu
                                v-if="datetype == 2"
                                ref="menu"
                                v-model="order_date_model"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on }">
                                    <div v-on="on">
                                        <v-text-field
                                            prepend-inner-icon="mdi-calendar"
                                            outlined
                                            clearable
                                            @click:clear="order_date = [],order_date_input = ''"
                                            v-model="order_date_input"
                                            maxlength="24"
                                            dense
                                        >
                                            <template v-slot:label>
                                                Order Date<span style="color:red">*</span>
                                            </template>
                                        </v-text-field>
                                    </div>
                                </template>
                                <v-date-picker
                                    range
                                    persistent-hint
                                    v-model="order_date"
                                >
                                <v-spacer></v-spacer>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="order_date_model = false"
                                    >OK</v-btn>
                                </v-date-picker>
                            </v-menu>
                            <v-menu
                                v-else
                                ref="menu"
                                v-model="delivery_date_model"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on }">
                                    <div v-on="on">
                                        <v-text-field
                                            prepend-inner-icon="mdi-calendar"
                                            outlined
                                            clearable
                                            maxlength="24"
                                            @click:clear="delivery_date = [],delivery_date_input =''"
                                            v-model="delivery_date_input"
                                            dense
                                        >
                                            <template v-slot:label>Order Delivery Date<span style="color:red">*</span></template>
                                        </v-text-field>
                                    </div>
                                </template>
                                <v-date-picker
                                    range
                                    v-model="delivery_date"
                                >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="delivery_date_model = false"
                                    >OK</v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="4" class="-mb30">
                            <SelectWarehouse
                                :norequired="true"
                                :aux_data="2"
                                :dense="true"
                                @selected="warehouseSelected"
                            ></SelectWarehouse>
                        </v-col>
                        <v-col cols="12" md="12">
                            <v-row>
                                <v-col cols="12" md="4" class="-mb30">
                                    <SelectMerchant
                                        @selected="merchantSelected"
                                        :norequired="true"
                                        :dense="true"
                                        :label="'Customer'"
                                    ></SelectMerchant>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-select
                                        v-model="datetype"
                                        :items="option"
                                        :dense="true"
                                        outlined
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <SelectBranch
                                        v-if="outlet"
                                        :norequired="true"
                                        :merchant="SelectMerchant"
                                        @selected="branchSelected"
                                        :label="'Outlet'"
                                        :dense="true"
                                    ></SelectBranch>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" md="3" class="flex-align-end mb30">
                    <v-btn
                        class="only-btn white--text px-10 py-5"
                        depressed
                        color="#50ABA3"
                        elevation="0"
                        @click="downloadData()"
                        :disabled="disableButton"
                        v-privilege="'sls_rpt_1_dl'"
                    >Download</v-btn>
                </v-col>
            </v-row>
        </div>
        <v-col cols="12" md="12">
            <v-layout justify-center>
                <v-card-actions>
                    <v-img
                    width="350"
                    src="/img/reportpacking.png"
                ></v-img>
                </v-card-actions>
            </v-layout>
            <v-layout justify-center>
                <span class="fs24 bold">Please download to view data</span>
            </v-layout>
        </v-col>
        <LoadingBar :value="overlay"/>
    </v-container>
</template>

<script>
    export default {
        name: "ReportSO",
        data() {
            return {
                order_date_input : new Date(Date.now() + ( 3600 * 1000 * 7)).toISOString().substr(0, 10),
                delivery_date_input : new Date(Date.now() + ( 3600 * 1000 * 7)).toISOString().substr(0, 10),
                search: '',
                order_date_model : '',
                order_date : [new Date(Date.now() + ( 3600 * 1000 * 7)).toISOString().substr(0, 10)],
                delivery_date_model : '',
                delivery_date : [new Date(Date.now() + ( 3600 * 1000 * 7)).toISOString().substr(0, 10)],
                loading: false,
                statuses:999,
                datetype:1,
                SelectArea : '',
                SelectMerchant : '',
                SelectBranch : '',
                SelectWarehouse : '',
                outlet : false,
                overlay: false,
                clearArea: false,
                option:[{
                    text:'Order Delivery Date',
                    value:1
                    },{
                    text:'Order Date',
                    value:2
                }],
            }
        },
        computed : {
            disableButton() {
                if (this.SelectArea && (this.order_date_input || this.delivery_date_input)) {
                    return false
                } else {
                    return true
                }
            },
        },
        mounted() {
        },
        methods: {
            downloadData(){
                this.overlay = true
                let area = ''
                if (this.SelectArea) {
                    area = this.SelectArea
                }
                let merchant = ''
                if (this.SelectMerchant) {
                    merchant = this.SelectMerchant
                }
                let branch = ''
                if (this.SelectBranch) {
                    branch = this.SelectBranch
                }
                let order_date = ''
                let delivery_date = ''
                if (this.datetype == 1) {
                    if (this.delivery_date.length > 0) {
                        if (this.delivery_date.length == 1) {
                            delivery_date = this.delivery_date[0]+'|'+this.delivery_date[0]
                        } else {
                            let date = this.delivery_date[0]
                            let date2 = this.delivery_date[1]
                            if (date > date2) {
                                delivery_date = date2+'|'+date
                            } else {
                                delivery_date = date+'|'+date2
                            }
                        }
                    }
                } else {
                    if (this.order_date.length > 0) {
                        if (this.order_date.length == 1) {
                            order_date = this.order_date[0]+'|'+this.order_date[0]
                        } else {
                            let date = this.order_date[0]
                            let date2 = this.order_date[1]
                            if (date > date2) {
                                order_date = date2+'|'+date
                            } else {
                                order_date = date+'|'+date2
                            }
                        }
                    }
                }
                let warehouse = ''
                if (this.SelectWarehouse) {
                    warehouse = this.SelectWarehouse
                }

                this.$http.get("/report/cms/sales-order?export=1",{params:{
                        area:area,
                        delivery_date:delivery_date,
                        warehouse:warehouse,
                        order_date:order_date,
                        branch:branch,
                        merchant:merchant,
                    }}).then(response => {
                        this.overlay = false
                        window.location.href = response.data.file
                }).catch(e => {
                    this.overlay = false
                    Vue.$toast.open({
                        position: 'top-right',
                        message: 'Something Wrong',
                        type: 'error',
                    });
                });
            },
            areaSelected(d) {
                this.SelectArea = ""
                this.clearArea = true
                if (d) {
                    this.clearArea = false
                    this.SelectArea = d.id
                }
            },
            merchantSelected(d) {
                this.outlet = false
                this.SelectMerchant = ""
                if (d) {
                    if (d.customer_group==1) {
                        this.outlet = true
                    }
                    this.SelectMerchant = d.id
                }

            },
            branchSelected(d) {
                this.SelectBranch = ""
                if (d) {
                    this.SelectBranch = d.id
                }
            },
            warehouseSelected(d) {
                this.SelectWarehouse = ""
                if (d) {
                    this.SelectWarehouse = d.id
                }
            },
        },
        watch: {
            'order_date_input': {
                handler: function (val) {
                    if (val) {
                        if (val.length == 10) {
                            let valid = this.$moment(val, 'YYYY-MM-DD', true).isValid()
                            if (valid == true) {
                                this.order_date[0] = this.$moment(val).format('YYYY-MM-DD')

                            }
                        } else if (val.length == 24) {
                            let date1 = val.substr(0,10)
                            let date2 = val.substr(14,23)
                            let valid1 = this.$moment(date1, 'YYYY-MM-DD', true).isValid()
                            let valid2 = this.$moment(date2, 'YYYY-MM-DD', true).isValid()
                            if (valid1 == true && valid2 == true) {
                                this.order_date[0] = this.$moment(date1).format('YYYY-MM-DD')
                                this.order_date[1] = this.$moment(date2).format('YYYY-MM-DD')
                                if (this.order_date.length == 2) {

                                }
                            }
                        }
                    }
                },
                deep: true
            },
            'order_date': {
                handler: function (val) {
                    if (val) {
                        this.order_date_input = this.formatDateRange(val)
                    }
                },
                deep: true
            },
            'delivery_date_input': {
                handler: function (val) {
                    if (val) {
                        if (val.length == 10) {
                            let valid = this.$moment(val, 'YYYY-MM-DD', true).isValid()
                            if (valid == true) {
                                this.delivery_date[0] = this.$moment(val).format('YYYY-MM-DD')

                            }
                        } else if (val.length == 24) {
                            let date1 = val.substr(0,10)
                            let date2 = val.substr(14,23)
                            let valid1 = this.$moment(date1, 'YYYY-MM-DD', true).isValid()
                            let valid2 = this.$moment(date2, 'YYYY-MM-DD', true).isValid()
                            if (valid1 == true && valid2 == true) {
                                this.delivery_date[0] = this.$moment(date1).format('YYYY-MM-DD')
                                this.delivery_date[1] = this.$moment(date2).format('YYYY-MM-DD')
                                if (this.delivery_date.length == 2) {

                                }
                            }
                        }
                    }
                },
                deep: true
            },
            'delivery_date': {
                handler: function (val) {
                    if (val) {
                        this.delivery_date_input = this.formatDateRange(val)
                    }
                },
                deep: true
            },
        },
    }
</script>
